import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ContractVersionsPageIncidenceRuleFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import getFieldKey from 'modules/contracts/lib/getFieldKey'

interface Props {
  pendingRules: ContractVersionsPageIncidenceRuleFragment[]
  employeeId: string
  contractVersionId: string
}

const TooltipContent = ({ pendingRules, employeeId, contractVersionId }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const fixContract = () => {
    navigate(
      navigation.employees.id.contractVersions.fix.fullPath({
        id: employeeId,
        contractVersionId: contractVersionId,
      })
    )
  }

  return (
    <Box textAlign="left" gap="s8">
      <Text.Normal weight="medium" size="200" color="grey1000">
        {i18n.t('contract_versions.header.tags.missing_data.tooltip')}
      </Text.Normal>
      <Box component="ul" style={{ listStyle: 'disc' }} alignItems="flexStart" paddingX="s32">
        {pendingRules.map((rule) => {
          return (
            <Box key={`rule-${rule.field}`} style={{ display: 'list-item' }} component="li">
              {getFieldKey(rule.field)}
            </Box>
          )
        })}
      </Box>
      <Box paddingTop="s8">
        <Button type="secondary" onClick={() => fixContract()}>
          {i18n.t('contract_versions.header.tags.missing_data.provide_data')}
        </Button>
      </Box>
    </Box>
  )
}

export default observer(TooltipContent)
